import MenuComponent from '@/components/MenuComponent'
import MenuConnexion from '@/components/MenuConnexion'
import BlocAuthenticated from '@/components/BlocAuthenticated'

export default {
  data () {
    return {
      loading: false,
      gestionnaire: ''
    }
  },
  components: {
    MenuComponent,
    MenuConnexion,
    BlocAuthenticated
  },
  methods: {
    getCivility () {
      if (this.$store.state.user.user.civility === 'MONSIEUR') {
        return 'M. '
      }
      if (this.$store.state.user.user.civility === 'MADEMOISELLE') {
        return 'Melle '
      }
      if (this.$store.state.user.user.civility === 'MADAME') {
        return 'Mme '
      }
    }
  },
  mounted () {
    this.loading = true

    this.$store.dispatch('porteur/getGestionnaire', this.$store.state.user.user.entrepriseId).then(
      response => {
        this.loading = false
        this.gestionnaire = response
      },
      error => {
        this.loading = false
        this.errorMessage = error.response
      }
    )
  },
  beforeCreate () {
    this.$store.state.filArianePage = 'Coordonnées porteur'
    this.$store.state.filArianeMiddlePage = null
    this.$store.state.filArianeMiddleRouterLink = null
  }
}
